import { routes } from "../../../constants/routes";
export const breadcrumbLink = [
  {
    label: "User Management",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "User Requests",
    link: routes.USER_REQUESTS,
    handleClick: () => {},
  },
];
export const UserRequestsFilterOptions = [
  {
    label: "First Name",
    value: false,
  },
  {
    label: "Last Name",
    value: false,
  },
  {
    label: "Email",
    value: false,
  },
];